import FaqBlockContent from './FaqBlockContent'

export default FaqBlockContent
